import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { track } from "@/lib/analytics";

interface CheckoutOptions {
  product?: string;
  plan?: string;
}

export function useCheckout() {
  const [loading, setLoading] = useState(false);

  const startCheckout = async ({ product, plan }: CheckoutOptions = {}) => {
    setLoading(true);
    try {
      track("checkout_initiated", { product: product ?? "vault", plan: plan ?? "default" });
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error("Not authenticated");

      const body: Record<string, string> = {};
      if (product) body.product = product;
      if (plan) body.plan = plan;

      const { data, error } = await supabase.functions.invoke("create-checkout", {
        headers: { Authorization: `Bearer ${session.access_token}` },
        body,
      });

      if (error) throw error;
      if (data?.url) {
        window.location.href = data.url;
      } else {
        throw new Error("No checkout URL returned");
      }
    } catch (err: any) {
      toast({
        title: "Checkout failed",
        description: err?.message || "Something went wrong. Please try again.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return { startCheckout, loading };
}
